/**
 * /devhub/white-label — White-label publish (operator). Surface Layer (/01). REQ-001.91 Phase 3.
 * Live operator panel (DevHubWhiteLabelPublishPanel) wired to its useDevHub* hook over GET /api/control/registry/:name.
 * Operator-only (routePolicy plane guard + DevHubPanelPage self-guard).
 */
import { createFileRoute } from '@tanstack/react-router';
import { DevHubWhiteLabelPublishPanel } from '../features/control-plane/DevHubWhiteLabelPublishPanel';
import { DevHubPanelPage } from '../components/devhub/DevHubPanelPage';

export const Route = createFileRoute('/devhub/white-label')({ component: WhiteLabelPage });

function WhiteLabelPage() {
  return (
    <DevHubPanelPage
      title="White-label publish"
      subtitle="White-label targets and publish gating."
      status={{ label: 'live', live: true }}
    >
      <DevHubWhiteLabelPublishPanel />
    </DevHubPanelPage>
  );
}
